import React from 'react';

export default function InfoTooltip({ text, className = '' }) {
  return (
    <span className={`relative inline-flex items-center ${className}`}>
      <span className="ml-1 inline-flex items-center justify-center w-4 h-4 rounded-full bg-gray-200 text-gray-700 text-[10px] cursor-default" title={text}>i</span>
    </span>
  );
}


